
<div class="export-grid my-account-form-container">
  <label class="label">Distributions: </label>
  <div class="actions">
    <terra-export-distributions-menu class="export-menu"></terra-export-distributions-menu>
  </div>
  <label class="label">Contributions: </label>
  <div class="actions">
    <terra-export-fundraisings-menu class="export-menu"></terra-export-fundraisings-menu>
  </div>
</div>

